import styled, { css } from 'styled-components';
import { SYS_BREAKPOINT_MD, SYS_SPACE_FIXED_200, SYS_BORDER_RADIUS_MD, SYS_BORDER_WIDTH_100 } from '@oneaudi/unified-web-alpha-common';
export const StyledPopoverContainer = styled.div `
  line-height: 0;
`;
const popoverPadding = SYS_SPACE_FIXED_200;
const defaultZIndex = 100000;
const arrowWidth = 23;
const arrowHeight = arrowWidth / 2;
export const StyledPopover = styled.div `
  position: fixed;
  z-index: ${(props) => props.zIndex ?? defaultZIndex};
  padding: ${popoverPadding};
  border-radius: ${SYS_BORDER_RADIUS_MD};
  background: ${(props) => props.theme.sys.gradient.elevation.level2.fill};
  will-change: filter;
  width: calc(100vw - 2 * ${popoverPadding} - 2 * var(--page-margin));
  max-width: calc(100vw - 2 * ${popoverPadding} - 2 * var(--page-margin));
  ${(props) => css `
    box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
      ${props.theme.sys.color.elevation.level2.stroke};
  `}
  filter: drop-shadow(0 6px 6px ${(props) => props.theme.sys.color.elevation.level2.shadowColor});

  // TODO: Token Missing
  transition-property: opacity, transform;
  transition-duration: 125ms;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  opacity: ${(props) => props.state === 'entered' || props.state === 'entering' ? 1 : 0};
  transform: ${(props) => props.state === 'entered' || props.state === 'entering'
    ? 'translateY(0px)'
    : 'translateY(-20px)'};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: max-content;
  }
`;
const arrowSvg = (direction, theme) => {
    const stops = theme.sys.color.elevation.level2.fill.stops;
    const width = arrowWidth;
    const height = arrowHeight;
    const points = direction === 'top'
        ? `0,0 ${width / 2},${height} ${width},0`
        : `0,${height} ${width / 2},0 ${width},${height}`;
    return `url("data:image/svg+xml;utf8,
    <svg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' viewBox='0 0 ${width} ${height}'>
      <defs>
        <linearGradient id='grad' x1='0.13' y1='0.93' x2='0.87' y2='0.07'>
          <stop offset='0%' stop-color='${stops[0]}'/>
          <stop offset='100%' stop-color='${stops[100]}'/>
        </linearGradient>
      </defs>
      <polygon points='${points}' fill='url(%23grad)'/>
    </svg>
  ")`;
};
export const StyledArrow = styled.div `
  position: absolute;
  top: var(--tip-top);
  left: var(--tip-left);
  right: var(--tip-right);
  width: ${arrowWidth}px;
  height: ${arrowHeight}px;
  background-repeat: no-repeat;
  background-size: cover;
  pointer-events: none;
  z-index: ${(props) => (props.zIndex ? props.zIndex - 1 : 99999)};
  background-image: ${(props) => arrowSvg(props.direction, props.theme)};
  display: none;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: block;
  }
`;
//# sourceMappingURL=index.styles.js.map